(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["manifesto-scanner"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.customElements && customElements.get('bliss-scanner')) return;

    var GLYPHS = ['░', '▒', '▓', '█'];
    var SCAN_INTERVAL = 60;
    var MORPH_DURATION = 180;
    var HOLD_DURATION = 450;
    var DISSOLVE_DURATION = 120;
    var MORPH_STEP = 20;

    function randInt(n) { return Math.floor(Math.random() * n); }

    function randGlyphs(n) {
      var s = '';
      for (var i = 0; i < n; i++) s += GLYPHS[randInt(GLYPHS.length)];
      return s;
    }

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    class BlissScanner extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        var raw = this.getAttribute('words') || '';
        this._words = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        var attrMax = parseInt(this.getAttribute('data-max-len'), 10);
        this._maxLen = !isNaN(attrMax) && attrMax > 0
          ? attrMax
          : this._words.reduce(function (m, w) { return Math.max(m, w.length); }, 4);

        // DOM is pre-rendered in Liquid — find it. Fall back to building it if missing.
        this._content = this.querySelector('.bliss-scanner__content');
        if (!this._content) {
          this.innerHTML =
            '<span class="bliss-scanner__bracket" aria-hidden="true">[</span>' +
            '<span class="bliss-scanner__content" aria-live="polite">████</span>' +
            '<span class="bliss-scanner__bracket" aria-hidden="true">]</span>';
          this._content = this.querySelector('.bliss-scanner__content');
        }

        this._mode = 'scan';
        this._wordSeq = 0;
        this._scanInterval = null;
        this._morphTimer = null;
        this._lastWord = null;
        this._hovered = false;

        this._onEnter = (e) => { this._hovered = true; this._enterWordMode(); };
        this._onLeave = (e) => { this._hovered = false; this._exitWordMode(); };
        this._onTap = (e) => { e.preventDefault(); this._toggleWordMode(); };

        // Multiple event types for maximum browser coverage.
        this.addEventListener('mouseenter', this._onEnter);
        this.addEventListener('mouseleave', this._onLeave);
        this.addEventListener('pointerenter', this._onEnter);
        this.addEventListener('pointerleave', this._onLeave);
        this.addEventListener('focus', this._onEnter);
        this.addEventListener('blur', this._onLeave);
        this.addEventListener('click', this._onTap);
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this._toggleWordMode();
          }
        });

        this._startScan();
      }

      disconnectedCallback() {
        this._clearTimers();
      }

      _clearTimers() {
        if (this._scanInterval) { clearInterval(this._scanInterval); this._scanInterval = null; }
        if (this._morphTimer) { clearTimeout(this._morphTimer); this._morphTimer = null; }
      }

      _startScan() {
        this._clearTimers();
        this._mode = 'scan';
        this.classList.remove('is-word');
        var content = this._content;
        var self = this;
        var n = this._maxLen;

        if (prefersReducedMotion()) {
          content.textContent = new Array(n + 1).join('█');
          return;
        }

        var tick = function () { content.textContent = randGlyphs(n); };
        tick();
        this._scanInterval = setInterval(tick, SCAN_INTERVAL);
      }

      _enterWordMode() {
        if (this._mode === 'word') return;
        this._clearTimers();
        this._mode = 'word';
        this.classList.add('is-word');
        this._wordSeq++;
        this._wordIndex = 0;
        this._cycleWord(this._wordSeq);
      }

      _exitWordMode() {
        if (this._mode !== 'word') return;
        this._wordSeq++;
        this._startScan();
      }

      _toggleWordMode() {
        if (this._mode === 'word') this._exitWordMode();
        else this._enterWordMode();
      }

      _pickWord() {
        if (this._words.length === 0) return '';
        if (typeof this._wordIndex !== 'number') this._wordIndex = 0;
        var word = this._words[this._wordIndex % this._words.length];
        this._wordIndex = (this._wordIndex + 1) % this._words.length;
        return word;
      }

      _cycleWord(seq) {
        var self = this;
        var word = this._pickWord();

        // resolve: glyphs morph into letters
        this._morphTo(word, MORPH_DURATION, seq, function () {
          if (self._wordSeq !== seq) return;

          // hold
          self._morphTimer = setTimeout(function () {
            if (self._wordSeq !== seq) return;

            // dissolve: letters back to glyphs
            self._morphTo(null, DISSOLVE_DURATION, seq, function () {
              if (self._wordSeq !== seq) return;
              self._cycleWord(seq);
            });
          }, HOLD_DURATION);
        });
      }

      _morphTo(target, duration, seq, done) {
        var self = this;
        var steps = Math.max(1, Math.floor(duration / MORPH_STEP));
        var i = 0;
        var word = target;
        var n = this._maxLen;

        var step = function () {
          if (self._wordSeq !== seq) return;
          var progress = i / steps;

          if (word) {
            // Probabilistic letter resolve at full max-len width — random glyphs
            // in slots outside the word, letters resolving in slots that map to the word.
            var out = '';
            for (var p = 0; p < n; p++) {
              if (p < word.length) {
                out += (Math.random() < progress) ? word[p] : GLYPHS[randInt(GLYPHS.length)];
              } else {
                out += GLYPHS[randInt(GLYPHS.length)];
              }
            }
            self._content.textContent = out;
          } else {
            self._content.textContent = randGlyphs(n);
          }

          i++;
          if (i >= steps) {
            self._content.textContent = word ? word : randGlyphs(n);
            done();
          } else {
            self._morphTimer = setTimeout(step, MORPH_STEP);
          }
        };
        step();
      }
    }

    if (!customElements.get('bliss-scanner')) {
      customElements.define('bliss-scanner', BlissScanner);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-guide-modal')) {
    class SizeGuideModal extends HTMLElement {
      connectedCallback() {
        this._closers = this.querySelectorAll('[data-size-guide-close]');
        this._unitButtons = this.querySelectorAll('[data-unit]');
        this._cells = this.querySelectorAll('td[data-in]');

        this._onKey = (e) => {
          if (e.key === 'Escape' && this.dataset.open === 'true') this.close();
        };

        this._closers.forEach((el) => el.addEventListener('click', () => this.close()));
        this._unitButtons.forEach((btn) =>
          btn.addEventListener('click', () => this.setUnit(btn.dataset.unit))
        );
        document.addEventListener('keydown', this._onKey);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this._onKey);
      }

      open() {
        this.hidden = false;
        this.dataset.open = 'true';
        document.documentElement.style.overflow = 'hidden';
        const focusTarget = this.querySelector('.size-guide__close');
        if (focusTarget) focusTarget.focus();
      }

      close() {
        this.hidden = true;
        delete this.dataset.open;
        document.documentElement.style.overflow = '';
      }

      setUnit(unit) {
        this._unitButtons.forEach((btn) => {
          const active = btn.dataset.unit === unit;
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
          const u = btn.dataset.unit.toUpperCase();
          btn.textContent = active ? '[' + u + ']' : u;
        });

        this._cells.forEach((cell) => {
          const value = unit === 'in' ? cell.dataset.in : cell.dataset.cm;
          const suffix = unit === 'in' ? '"' : ' cm';
          cell.textContent = value + suffix;
        });
      }
    }

    customElements.define('size-guide-modal', SizeGuideModal);

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-size-guide-open]');
      if (!trigger) return;
      const id = trigger.getAttribute('data-size-guide-open');
      const modal = document.getElementById(id);
      if (modal && typeof modal.open === 'function') {
        e.preventDefault();
        modal.open();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["transmission"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.customElements && customElements.get('bliss-transmission')) return;

    var STORAGE_DATA = 'bliss_transmission_data';
    var STORAGE_BOOTED = 'bliss_transmission_booted';
    var STORAGE_COLLAPSED = 'bliss_transmission_collapsed';

    function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

    function safeGet(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }
    function safeSet(key, val) { try { sessionStorage.setItem(key, val); } catch (e) {} }

    function mapWeather(data) {
      if (!data || !data.weather || !data.weather[0]) return '—';
      var main = (data.weather[0].main || '').toUpperCase();
      var desc = (data.weather[0].description || '').toUpperCase();
      if (main === 'CLEAR') return 'CLEAR';
      if (main === 'CLOUDS') {
        if (desc.indexOf('OVERCAST') !== -1) return 'OVERCAST';
        if (desc.indexOf('FEW') !== -1 || desc.indexOf('SCATTERED') !== -1) return 'PARTLY CLOUDY';
        return 'CLOUDY';
      }
      if (main === 'RAIN') {
        if (desc.indexOf('LIGHT') !== -1) return 'LIGHT RAIN';
        if (desc.indexOf('HEAVY') !== -1) return 'HEAVY RAIN';
        return 'RAIN';
      }
      if (main === 'DRIZZLE') return 'LIGHT RAIN';
      if (main === 'SNOW') return 'SNOW';
      if (main === 'THUNDERSTORM') return 'STORM';
      if (['MIST', 'FOG', 'HAZE', 'SMOKE'].indexOf(main) !== -1) return 'FOG';
      return main || '—';
    }

    function getPhase(date) {
      var t = date.getHours() + date.getMinutes() / 60;
      if (t >= 5 && t < 7) return 'DAWN';
      if (t >= 7 && t < 17) return 'DAY';
      if (t >= 17 && t < 19.5) return 'DUSK';
      return 'NIGHT';
    }

    function pad(n) { return String(n).padStart(2, '0'); }

    class BlissTransmission extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        this._statusEl = this.querySelector('[data-field="status"]');
        this._locationEl = this.querySelector('[data-field="location"]');
        this._timeEl = this.querySelector('[data-field="time"]');
        this._phaseEl = this.querySelector('[data-field="phase"]');
        this._weatherEl = this.querySelector('[data-field="weather"]');
        this._closerEl = this.querySelector('[data-field="closer"]');

        var collapseBtn = this.querySelector('[data-action="collapse"]');
        var expandBtn = this.querySelector('[data-action="expand"]');
        if (collapseBtn) collapseBtn.addEventListener('click', this.collapse.bind(this));
        if (expandBtn) expandBtn.addEventListener('click', this.expand.bind(this));

        // Default collapsed (set in markup). Only expand if the user
        // explicitly expanded it earlier this session.
        if (safeGet(STORAGE_COLLAPSED) === '0') {
          delete this.dataset.collapsed;
        }

        var self = this;
        requestAnimationFrame(function () { self.setAttribute('data-visible', 'true'); });

        var cached = this._readCache();
        var alreadyBooted = safeGet(STORAGE_BOOTED) === '1';

        if (cached && alreadyBooted) {
          this._applyData(cached);
          this._setState(cached.error ? 'error' : 'active');
          this._startClock();
        } else {
          this._bootup();
        }
      }

      async _bootup() {
        this._setState('connecting');
        await wait(200);
        this._setState('warming');
        await wait(300);

        var data;
        try {
          data = await this._fetchData();
        } catch (err) {
          data = { error: true };
        }

        this._writeCache(data);
        safeSet(STORAGE_BOOTED, '1');
        this._applyData(data);
        this._setState(data.error ? 'error' : 'active');
        this._startClock();
      }

      async _fetchData() {
        var ipResp = await fetch('https://ipapi.co/json/');
        if (!ipResp.ok) throw new Error('ipapi failed');
        var ip = await ipResp.json();
        if (ip.error) throw new Error('ipapi error');

        var city = (ip.city || '').toUpperCase();
        var region;
        if (ip.country_code === 'US') {
          region = (ip.region_code || ip.region || '').toUpperCase();
        } else {
          region = (ip.country_name || ip.country || '').toUpperCase();
        }
        var location = city && region ? city + ', ' + region : (city || region || 'LOCATION UNKNOWN');

        var weather = '—';
        var temp = null;
        var apiKey = this.dataset.weatherKey;
        if (apiKey && ip.latitude && ip.longitude) {
          try {
            var wResp = await fetch(
              'https://api.openweathermap.org/data/2.5/weather?lat=' +
              encodeURIComponent(ip.latitude) + '&lon=' +
              encodeURIComponent(ip.longitude) + '&units=imperial&appid=' + encodeURIComponent(apiKey)
            );
            if (wResp.ok) {
              var wData = await wResp.json();
              weather = mapWeather(wData);
              if (wData.main && typeof wData.main.temp === 'number') {
                temp = Math.round(wData.main.temp);
              }
            }
          } catch (e) {}
        }

        return { location: location, weather: weather, temp: temp };
      }

      _applyData(data) {
        if (data.error) {
          this._locationEl.textContent = 'LOCATION UNKNOWN';
          this._weatherEl.textContent = '—';
        } else {
          this._locationEl.textContent = data.location || 'LOCATION UNKNOWN';
          var weatherStr = data.weather || '—';
          if (data.temp !== null && data.temp !== undefined) {
            weatherStr = data.temp + '° / ' + weatherStr;
          }
          this._weatherEl.textContent = weatherStr;
        }
      }

      _setState(state) {
        this.dataset.state = state;
        if (state === 'connecting' || state === 'warming') {
          this._statusEl.textContent = 'CONNECTING';
        } else if (state === 'active') {
          this._statusEl.textContent = 'ACTIVE';
        } else if (state === 'error') {
          this._statusEl.textContent = 'UNKNOWN';
          this._closerEl.textContent = 'SIGNAL LOST';
        }
      }

      _startClock() {
        var self = this;
        var tick = function () {
          var now = new Date();
          self._timeEl.textContent = pad(now.getHours()) + ':' + pad(now.getMinutes());
          if (self.dataset.state !== 'error') {
            self._phaseEl.textContent = getPhase(now);
          } else {
            self._phaseEl.textContent = '—';
          }
        };
        tick();
        if (this._clockInterval) clearInterval(this._clockInterval);
        this._clockInterval = setInterval(tick, 30000);
      }

      _readCache() {
        var raw = safeGet(STORAGE_DATA);
        if (!raw) return null;
        try { return JSON.parse(raw); } catch (e) { return null; }
      }

      _writeCache(data) {
        try { safeSet(STORAGE_DATA, JSON.stringify(data)); } catch (e) {}
      }

      collapse() {
        safeSet(STORAGE_COLLAPSED, '1');
        this.dataset.collapsed = 'true';
      }

      expand() {
        safeSet(STORAGE_COLLAPSED, '0');
        delete this.dataset.collapsed;
      }

      disconnectedCallback() {
        if (this._clockInterval) clearInterval(this._clockInterval);
      }
    }

    if (!customElements.get('bliss-transmission')) {
      customElements.define('bliss-transmission', BlissTransmission);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
